import { render, staticRenderFns } from "./store-order.vue?vue&type=template&id=28ba6a7d&scoped=true"
import script from "./store-order.vue?vue&type=script&lang=js"
export * from "./store-order.vue?vue&type=script&lang=js"
import style0 from "./store-order.vue?vue&type=style&index=0&id=28ba6a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba6a7d",
  null
  
)

export default component.exports